import classNames from 'classnames';
import Overflow from '@alltrails/shared/icons/Overflow';
import { COLOR_INTERACTIVE_DEFAULT } from '@alltrails/shared/denali/tokens';
import ActionBarItem from 'components/ActionBarItem';
import { logTrailDetailsOverflowClicked } from 'utils/trail_analytics_helpers';
import TrailMoreAlternateDropDownList from '../../../../components/TrailDetails/TrailMoreAlternateDropDownList';
import * as styles from './styles.module.scss';

const createReactClass = require('create-react-class');

const TrailMoreAlternateMenuItem = createReactClass({
  getInitialState() {
    return {
      dropDownOpen: false,
      modalOpen: false
    };
  },
  componentDidMount() {
    const isMobileWidth = (window && window.innerWidth <= 767) || this.props.exploreFlag;
    window.addEventListener('resize', this.handleResize);
    this.setState({ isMobileWidth });
  },
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  handleResize() {
    const isMobileWidth = window && window.innerWidth <= 767;
    this.setState({ isMobileWidth });
  },
  modalIsOpen(modalOpen) {
    this.setState({ modalOpen });
  },
  handleMouseClick(e) {
    e.preventDefault();
    logTrailDetailsOverflowClicked(this.props.trail.ID);
    if (e.currentTarget.classList.contains('moreAction')) {
      this.setState({ dropDownOpen: !this.state.dropDownOpen });
    }
  },
  handleMouseEnter() {
    if (this.props.mobileBrowser || this.state.modalOpen) {
      return;
    }

    this.setState({ dropDownOpen: true });
  },
  handleMouseLeave() {
    if (this.props.mobileBrowser || this.state.modalOpen) {
      return;
    }

    this.setState({ dropDownOpen: false });
  },

  render() {
    return (
      <div
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        className={classNames('xlate-none', 'moreContainer', styles.moreContainer)}
      >
        <ActionBarItem
          title={this.props.intl.formatMessage({ defaultMessage: 'More' })}
          icon={<Overflow color={COLOR_INTERACTIVE_DEFAULT} />}
          onClick={this.handleMouseClick}
          className="moreAction"
          testId="more-action"
        />
        {this.state.dropDownOpen && (
          <TrailMoreAlternateDropDownList
            modalIsOpen={this.modalIsOpen}
            trail={this.props.trail}
            pending={this.props.pending}
            exploreFlag={this.props.exploreFlag}
            printUrl={this.props.printUrl}
            mobileBrowser={this.props.mobileBrowser}
            isMobileWidth={this.state.isMobileWidth}
          />
        )}
      </div>
    );
  }
});

export { TrailMoreAlternateMenuItem };
